import React from 'react';
import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';

import FormCrearLicencia from './FormCrearLicencia';
import insertLicencia from '../../../graphql/mutations/rrhh/InsertLicencia.graphql';
import getLicencias from '../../../graphql/querys/rrhh/getLicencias.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

@compose(
  graphql(insertLicencia, {
    name: 'insertLicencia',
    options: {
      refetchQueries: [{ query: getLicencias }],
    },
  }),
  graphql(getUsuario)
)
class CrearLicencia extends React.Component {
  onSubmit = values => {
    let fechaInicio = values.fechaInicio.toDate();
    let fechaFin = values.fechaFin.toDate();

    let nuevoObj = {
      ...values,
      fechaFin: fechaFin,
      fechaInicio: fechaInicio,
    };

    this.props
      .insertLicencia({
        variables: {
          objLicencia: nuevoObj,
        },
      })
      .then(res => {
        if (res.data.insertLicencia._id) {
          notification.success({
            message: 'Licencia Registrada',
            description:
              'El licencia se registró correctamente en la base de datos',
          });
          this.props.history.push('/');
        }
      })
      .catch(err => {
        console.log('Existio un error a la hora de crear el licencia');
        console.log(err);

        Modal.error({
          title: 'Error en la creacion del licencia',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  render() {
    return (
      <div>
        <br />
        <FormCrearLicencia
          history={this.props.history}
          onSubmit={this.onSubmit}
        />
      </div>
    );
  }
}

export default withApollo(CrearLicencia);
